import React, { useEffect, useState, useRef } from 'react'
import Select from 'react-select'
import DefaultContacts from './components/DefaultContacts'
import FinanceTerms from './components/FinanceTerms'
import Brand from './components/Brand'
import messages from "./messages";
import {FormattedMessage, useIntl} from "react-intl";
import { Full as Loading } from 'components/Loading'

const EmbeddedCompanyPage = ({ match }) => {
  const [state, setState] = useState(null)
  const [initialState, setInitialState] = useState(null)
  const [loaded, setLoaded] = useState(false)
  const [showBrand, setShowBrand] = useState(false)
  const [syncing, setSyncing] = useState(false)
  const [saving, setSaving] = useState(false)
  const interval = useRef()
  const { formatMessage } = useIntl()

  const classifications = {
    SMALL: { value: 'SMALL', label: formatMessage(messages.small) + ' (< 1,000 EUR)' },
    MEDIUM: { value: 'MEDIUM', label: formatMessage(messages.medium) + ' (1,001 - 7,000 EUR)' },
    LARGE: { value: 'LARGE', label: formatMessage(messages.large) + ' (7,001 - 30,000 EUR)' },
    KEY: { value: 'KEY', label: formatMessage(messages.key) + ' (30,000+ EUR)' },
  }

  useEffect(() => {
    fetchCustomer()
  }, [])

  const fetchCustomer = () => {
    fetch(`/rest/v1/customer?search[company]=${match.params.companyId}&includeRelations=1`) 
      .then((response) => response.json())
      .then(([customer]) => {
        setLoaded(true)
        if (customer) {
          setInitialState(customer)
          setState(customer)
          if (interval.current) {
            setSyncing(false)
            clearInterval(interval.current)
          }
        }
      }).catch((err) => {
        console.error(err)
      })
  }

  const onSave = () => {
    setSaving(true)
    fetch(`/rest/v1/customer/${state.uid}`, {
      method: 'put',
      body: JSON.stringify({
        primary_coordinator_uid: state.primary_coordinator_uid,
        secondary_coordinator_uid: state.secondary_coordinator_uid,
        primary_producer_uid: state.primary_producer_uid,
        secondary_producer_uid: state.secondary_producer_uid,
        defaultcontact: state.defaultcontact,
        cccontact: state.cccontact,
        hl_exclude: state.hl_exclude,
        poRequired: state.poRequired,
        classification: state.classification,
        economicTermOfPaymentHandle: state.economicTermOfPaymentHandle,
        economicDebtorGroupHandle: state.economicDebtorGroupHandle,
      })
    }).then((response) => {
      setSaving(false)
      setInitialState(state)
    }).catch((error) => {
      window.alert(error)
    })
  }


  if (!loaded) {
    return (
      <Loading />
    )
  }

  const onSync = () => {
    setSyncing(true)

    interval.current = setInterval(fetchCustomer, 250)

    fetch(`/embedded/company/${match.params.companyId}/customer`, { method: 'post' })
      .catch((err) => {
        window.alert(err)
      })
  }

  if (loaded && !state && !syncing) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <button className="px-6 py-3 font-medium uppercase text-white" style={{ backgroundColor: '#3bc8f5' }} onClick={onSync}>
          <i className="fa fa-sync mr-2" /> <FormattedMessage {...messages.synchronize}/>
        </button>
      </div>
    )
  }

  if (loaded && !state && syncing) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <div className="w-1/2 sm:w-1/3 lg:w-1/4">
          <div className="border border-gray-300 p-4 bg-white flex justify-between items-center animate-pulse">
            <div>
              <div className="text-gray-400"><FormattedMessage {...messages.company}/></div>
              <div className="mt-3 h-8 w-64 bg-gray-300 block" />
              <div className="mt-2 h-4 w-48 bg-gray-300 block" />
            </div>
            <div>
              <span className="inline-block w-10 h-10 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: '#3bc8f5' }}>
                <i className="fa fa-sync animate-spin" />
              </span>
            </div>
          </div>

          <button className="px-6 py-3 text-white font-medium uppercase mt-4" style={{ backgroundColor: '#3bc8f5' }}>
            <i className="fa fa-sync animate-spin mr-2" /> <FormattedMessage {...messages.synchronizing}/>
          </button>
        </div>
      </div>
    )
  }

  return (
      <div className="w-full h-full flex">
        <div className="w-3/5 flex justify-center items-center">
          <div className="w-1/2">
            <div className="border border-gray-300 p-4 bg-white flex justify-between items-center">
              <div>
                <div className="text-gray-400"><FormattedMessage {...messages.company}/></div>
                <div className="text-gray-700 text-2xl mt-3">{ state.name }</div>
                <div className="text-gray-700 mt-1 font-medium">{ state.phone }, { state.email}</div>
              </div>
              <div>
                <span className="inline-block w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#9ece00' }}>
                  <i className="fa fa-check text-white" />
                </span>
              </div>
            </div>
            <div className="flex mt-3 justify-between">
              <a href={`https://system.voicearchive.com/customers/${state.uid}`} target="_blank" className="inline-block">
                <button className="px-6 py-3 text-white font-medium uppercase" style={{ background: '#3bc8f5' }}>
                  <i className="fa fa-external-link" /> <FormattedMessage {...messages.openInAme}/>
                </button>
              </a>

              <div>
                { JSON.stringify(initialState) !== JSON.stringify(state) &&
                  <button className="px-6 py-3 text-gray-800 font-medium uppercase mr-2" onClick={() => setState(initialState)}>Cancel</button>
                }
                { saving ? (
                  <button className="px-6 py-3 text-white font-medium uppercase" style={{ background: '#9ece00' }}>
                    <i className="fa fa-sync animate-spin" /> <FormattedMessage {...messages.saving}/>
                  </button>
                ) : (
                  <button className="px-6 py-3 text-white font-medium uppercase" style={{ background: '#9ece00' }} onClick={onSave}>
                    <i className="fa fa-save" /> <FormattedMessage {...messages.save}/>
                  </button>
                ) }
              </div>
            </div>

            <div className="mt-12">
              { showBrand && state.uid ? (
                <Brand customerId={state.uid} />
              ) : (
                <button
                  className="w-full tex-center py-3 text-gray-800 font-medium uppercase border border-gray-200 hover:bg-gray-100"
                  onClick={() => setShowBrand(true)}
                >
                  Customize Brand
                </button>
              ) }
            </div>
          </div>
        </div>

        <div className="w-2/5 flex flex-col justify-around px-8 border-l-2 border-gray-300 bg-gray-100 shadow-inner">
          <div>
            <FinanceTerms
              state={state}
              setState={setState}
            />

            <div className="mb-6">
              <div className="text-gray-500 mb-2"><FormattedMessage {...messages.classification}/></div>
              <Select
                value={classifications[state.classification]}
                onChange={({ value }) => setState((state) => ({ ...state, classification: value }))}
                openMenuOnFocus
                options={Object.values(classifications)}
              />
            </div>

            <div className="flex justify-between items-center">
              <div>
                <input type="checkbox" name="newsletter" checked={!Boolean(Number(state.hl_exclude))} onChange={({ target }) => setState({ ...state, hl_exclude: target.checked ? "0" : "1" })} />
                <label htmlFor="newsletter" className="ml-2 -mt-2">
                  <FormattedMessage {...messages.subscribe}/>
                </label>
              </div>

              <div>
                <input type="checkbox" name="purchase-order" checked={Boolean(Number(state.poRequired))} onChange={({ target }) => setState({ ...state, poRequired: target.checked ? "1" : "0" })} />
                <label htmlFor="purchase-order" className="ml-2 -mt-2">
                  <FormattedMessage {...messages.requirePurchase}/>
                </label>
              </div>
            </div>
          </div>

          <DefaultContacts
            primary={state.primary_coordinator_uid ? { value: state.primary_coordinator_uid, label: state.primary_coordinator.name } : null}
            secondary={state.secondary_coordinator_uid ? { value: state.secondary_coordinator_uid, label: state.secondary_coordinator.name } : null}
            setPrimary={({ value, label }) => setState({ ...state, primary_coordinator_uid: value, primary_coordinator: { name: label } })}
            setSecondary={({ value, label }) => setState({ ...state, secondary_coordinator_uid: value, secondary_coordinator: { name: label } })}
            name={formatMessage(messages.deliveryResponsible)}
            resolveUrl={(query) => `/rest/v2/coordinator?search[name]=${query}`}
          />

          <DefaultContacts
            primary={state.primary_producer_uid ? { value: state.primary_producer_uid, label: state.primary_producer.userid } : null}
            secondary={state.secondary_producer_uid ? { value: state.secondary_producer_uid, label: state.secondary_producer.userid } : null}
            setPrimary={({ value, label }) => setState({ ...state, primary_producer_uid: value, primary_producer: { userid: label } })}
            setSecondary={({ value, label }) => setState({ ...state, secondary_producer_uid: value, secondary_producer: { userid: label } })}
            name={formatMessage(messages.contact)}
            labelKey="userid"
            resolveUrl={(query) => `/rest/v2/supplier/?search[type]=3&search[identifier]=${query}`}
          />

          <DefaultContacts
            primary={state.defaultcontact ? { value: state.defaultcontact, label: state.primary_contact.name } : null}
            secondary={state.cccontact ? { value: state.cccontact, label: state.secondary_contact.name } : null}
            setPrimary={({ value, label }) => setState({ ...state, defaultcontact: value, primary_contact: { name: label } })}
            setSecondary={({ value, label }) => setState({ ...state, cccontact: value, secondary_contact: { name: label } })}
            name={formatMessage(messages.companyContact)}
            resolveUrl={(query) => `/rest/v1/customer/${state.uid}/contacts?search[name]=${query}`}
          />
        </div>
      </div>
  )
}

export default EmbeddedCompanyPage
